"use client";
import React, { useState } from "react";
import Image from "next/image";
import ModalLang from "../ModalLang/ModalLang";
import { countries } from "@/constants/data";
import { useAppSelector } from "@/lib/store/hooks";
import logoCeedow from "../../../../public/logo-ceedow.png";
import { LuBell } from "react-icons/lu";
import Link from "next/link";
import { useAuthContext } from "@/contexts/AuthContext";
import { User2 } from "lucide-react";
import { useRouter } from "next/navigation";

const Navbar = () => {
  const router = useRouter();
  const { isAuthenticated } = useAuthContext();
  const [openModalLang, setOpenModalLang] = useState(false);
  const countryCode = useAppSelector((state) => state.lang.lang);
  const selectedCountry =
    countries.find((country) => country.code === countryCode) || countries[0];
  const newNotifs = useAppSelector((state) => state.notifications.isNotRead);
  const redirectHome = () => {
    router.push("/");
  };
  //const isMobileXs = useMediaQuery("(max-width: 410px)");

  return (
    <div className="fixed flex items-center justify-between sm:invisible sm:hidden lg:hidden z-50 bg-white p-4 sm:p-0 border-b border-gray-300 md:fixed lg:fixed left-0 w-full top-0 ">
      <span className={`text-2xl font-extrabold px-3"`} onClick={redirectHome}>
        <Image
          src={logoCeedow}
          className=" object-contain"
          width={123}
          height={40}
          quality={100}
          alt={"logo"}
          priority
        />
      </span>
      <div className="flex space-x-6 items-center">
        <span className="cursor-pointer" onClick={() => setOpenModalLang(true)}>
          {selectedCountry.flag}
        </span>
        <Link href={isAuthenticated ? "/notifications" : "/auth/signin"}>
          <span className="relative">
            {isAuthenticated ? (
              <LuBell className="text-primary cursor-pointer" size={25} />
            ) : (
              <User2 className="text-secondary" />
            )}
            {newNotifs > 0 && (
              <span className="absolute z-20 -top-1 left-3 w-4 h-4 rounded-full bg-primary text-white text-[9px] flex items-center justify-center text-center">
                {newNotifs}
              </span>
            )}
          </span>
        </Link>
      </div>
      {/* Modal for language */}
      <ModalLang
        openModalLang={openModalLang}
        setOpenModalLang={setOpenModalLang}
      />
    </div>
  );
};

export default Navbar;
